import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorManagementContentSearch = () => {
  const contentSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/content/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { contentSearch }
}

export default InteractorManagementContentSearch
